import React, { Component } from "react";
import { connect } from "react-redux";
import { addNewAddress } from "../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ililce from "../helpers/ililce";
import styles from "../thema/style";
import { formatPhoneDisplay, formatPhoneInput, formatPhoneForDatabase, handlePhoneChange } from "../helpers/phoneFormatter";

class NewAddressForm extends Component {
  state = {
    first_name: "",
    last_name: "",
    city: "",
    town: "",
    address: "",
    phone: "",
    address_name: "",
    invoice_type: "individual",
    company_name: "",
    tax_number: "",
    tax_office: ""
  };

  constructor(props) {
    super(props);
    this.close = React.createRef();
  }

  handleChange = e => {
    if (e.target.name === 'phone') {
      handlePhoneChange(e, this.setState.bind(this));
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  resetForm = () => {
    this.setState({
      first_name: "",
      last_name: "",
      city: "",
      town: "",
      address: "",
      phone: "",
      address_name: "",
      invoice_type: "individual",
      company_name: "",
      tax_number: "",
      tax_office: ""
    });
  };

  onSubmit = e => {
    e.preventDefault();
    const submitData = { ...this.state };
    if (this.state.invoice_type !== "corporate") {
      delete submitData.company_name;
      delete submitData.tax_number;
      delete submitData.tax_office;
    }
    this.props.addNewAddress(submitData);
    this.close.current.click();
    this.resetForm();
  };

  render() {
    return (
      <div
        className="modal fade modern-modal"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                <FontAwesomeIcon icon="plus" />
                Yeni Adres Ekle
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.resetForm}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={this.onSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Adres Adı</label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    name={"address_name"}
                    value={this.state.address_name}
                    onChange={e => {
                      this.handleChange(e);
                    }}
                  />
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <label>Ad</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        name={"first_name"}
                        value={this.state.first_name}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>Soyad</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        name={"last_name"}
                        value={this.state.last_name}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <label>İl</label>
                      <select
                        required
                        className="form-control"
                        name={"city"}
                        value={this.state.city}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                      >
                        <option value=""> --Seçiniz-- </option>
                        {ililce.map((item, i) => (
                          <option key={i} value={item.il}>
                            {item.il}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label>İlçe</label>
                      <select
                        required
                        className="form-control"
                        name={"town"}
                        value={this.state.town}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                      >
                        <option value=""> --Seçiniz-- </option>
                        {this.state.city != "" &&
                          ililce
                            .find(item => item.il === this.state.city)
                            .ilceleri.map((item, idx) => (
                              <option key={idx} value={item}>{item}</option>
                            ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label>İletişim Telefon</label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    name={"phone"}
                    value={formatPhoneDisplay(this.state.phone)}
                    placeholder="555 555 55 55"
                    maxLength="13"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                  />
                </div>

                <div className="form-group">
                  <label>Adres</label>
                  <textarea
                    required
                    rows="3"
                    type="text"
                    className="form-control"
                    name={"address"}
                    value={this.state.address}
                    onChange={e => {
                      this.handleChange(e);
                    }}
                  />
                </div>

                <div className="form-group">
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="corporateInvoiceCheckbox"
                      checked={this.state.invoice_type === "corporate"}
                      onChange={e => {
                        this.setState({
                          invoice_type: e.target.checked ? "corporate" : "individual"
                        });
                      }}
                    />
                    <label className="custom-control-label" htmlFor="corporateInvoiceCheckbox">
                      Kurumsal Fatura Bilgisi Girmek İstiyorum
                    </label>
                  </div>
                </div>

                {this.state.invoice_type === "corporate" && (
                  <div className="corporate-invoice-fields">
                    <div className="form-group">
                      <label>Firma Adı *</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        name={"company_name"}
                        value={this.state.company_name}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Vergi Numarası *</label>
                          <input
                            required
                            type="text"
                            className="form-control"
                            name={"tax_number"}
                            value={this.state.tax_number}
                            onChange={e => {
                              this.handleChange(e);
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <label>Vergi Dairesi *</label>
                          <input
                            required
                            type="text"
                            className="form-control"
                            name={"tax_office"}
                            value={this.state.tax_office}
                            onChange={e => {
                              this.handleChange(e);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  ref={this.close}
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={this.resetForm}
                >
                  İptal
                </button>
                <button type="submit" className="btn btn-success">
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { addNewAddress };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewAddressForm);



// WEBPACK FOOTER //
// ./src/components/NewAddressForm.js